(function($) {
  "use strict";
  var swipernewin = new Swiper('.swiper-newin',{
    nextButton: '.button-next',
    prevButton: '.button-prev',
    slidesPerView: 4,
    spaceBetween: 30,
    breakpoints: {
      479: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      // when window width is <= 640px
      767: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      // when window width is <= 768px
      991: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      // when window width is <= 992px
      1819: {
        slidesPerView: 4,
        spaceBetween: 30
      },
      2500: {
        slidesPerView: 4,
        spaceBetween: 30
      }
    },
    loop:true
  });
  
  var swiperdeals = new Swiper('.engoj-deals',{
    pagination: '.swiper-pagination',
    spaceBetweenSlides: 0,
    paginationClickable: true
  })

  var tesimonial = new Swiper('.testimonial-content-gallery', {
    loop:true,
    centeredSlides: true,
    loopedSlides: 5 //looped slides should be the same
  });
  var tesimonialThumbs = new Swiper('.testimonial-thumbs', {
    slidesPerView: 5,
    touchRatio: 0.2,
    loop:true,
    centeredSlides: true,
    loopedSlides: 5, //looped slides should be the same
    slideToClickedSlide: true
  });
  tesimonial.params.control = tesimonialThumbs;
  tesimonialThumbs.params.control = tesimonial;


  var swiper = new Swiper('.swiper-main',{
    pagination: '.swiper-pagination',
    paginationClickable: true
  });
  var swiperproduct = new Swiper('.swiper-product',{
    slidesPerView: 3,
    touchRatio: 0.2,
    loop:true,
    centeredSlides: true,
    loopedSlides: 3, //looped slides should be the same
    slideToClickedSlide: true,
    autoplay: 3000,
    grabCursor: true,
    breakpoints: {
      767: {
        slidesPerView: 1,
      }
    },
    autoplayDisableOnInteraction: false
  })

  $('.swiper-slide').on('mouseover',function() {
//     swiperproduct.stopAutoplay();
  });
  $('.swiper-slide').on('mouseout',function() {
//     swiperproduct.startAutoplay();
  });


  var swiperproduct2 = new Swiper('.swiper-product-02',{
    slidesPerView: 3,
    touchRatio: 0.2,
    loop:true,
    centeredSlides: true,
    loopedSlides: 3, //looped slides should be the same
    slideToClickedSlide: true,
    autoplay: 3000,
    breakpoints: {
      767: {
        slidesPerView: 1,
      }
    },
    autoplayDisableOnInteraction: false
  })

  $('.swiper-slide').on('mouseover',function() {
//     swiperproduct2.stopAutoplay();
  });
  $('.swiper-slide').on('mouseout',function() {
//     swiperproduct2.startAutoplay();
  });

})(jQuery);